/** @format */

import {
  KPIConfig,
  YalperAnalyticAttributionModelEnum,
} from 'pages/Home/Project/Steps/Periods/interfaces';

export interface AttributionModelOption {
  value: YalperAnalyticAttributionModelEnum;
  label: string;
}

export const clickPaymentKPIs: KPIConfig[] = [
  {
    id: 'CPL',
    name: 'CPL',
    description: 'Стоимость одного лида, считается по целям из Яндекс Метрики',
    needsMetricGoals: true,
  },
  {
    id: 'DRR',
    name: 'ДРР',
    description:
      'Доля рекламных расходов, считается на основе данных из Яндекс Директа и Яндекс Метрики',
  },
  {id: 'ROMI', name: 'ROMI'},
  {id: 'REVENUE', name: 'Доход'},
  {id: 'CLICKS', name: 'Клики'},
  {id: 'CPC', name: 'CPC'},
  {id: 'IMPRESSIONS', name: 'Показы'},
  {id: 'CONVERSIONS', name: 'Лиды', needsMetricGoals: true},
];

export const impressionPaymentKPIs: KPIConfig[] = [
  {id: 'CPM', name: 'CPM'},
  {id: 'IMPRESSIONS', name: 'Показы'},
  {
    id: 'AVG_VIDEO_COMPLETE_COST',
    name: 'Ср. цена досмотра 100% ролика (руб.)',
  },
  {id: 'REACH', name: 'Охват'},
  {id: 'ER', name: 'ER'},
  {id: 'VTR', name: 'VTR'},
  {id: 'CONVERSIONS', name: 'Лиды', needsMetricGoals: true},
];

export const ATTRIBUTION_MODELS: AttributionModelOption[] = [
  {
    value: YalperAnalyticAttributionModelEnum.AUTOMATIC,
    label: 'Автоматическая',
  },
  {
    value: YalperAnalyticAttributionModelEnum.FIRST,
    label: 'Первый переход',
  },
  {
    value: YalperAnalyticAttributionModelEnum.LAST,
    label: 'Последний переход',
  },
  {
    value: YalperAnalyticAttributionModelEnum.LASTSIGN,
    label: 'Последний значимый переход',
  },
  {
    value: YalperAnalyticAttributionModelEnum.LAST_YANDEX_DIRECT_CLICK,
    label: 'Последний клик из Яндекс.Директа',
  },
  {
    value: YalperAnalyticAttributionModelEnum.CROSS_DEVICE_FIRST,
    label: 'Первое взаимодействие на всех устройствах',
  },
  {
    value: YalperAnalyticAttributionModelEnum.CROSS_DEVICE_LAST,
    label: 'Последнее взаимодействие на всех устройствах',
  },
  {
    value: YalperAnalyticAttributionModelEnum.CROSS_DEVICE_LAST_SIGNIFICANT,
    label: 'Последнее значимое взаимодействие на всех устройствах',
  },
  {
    value: YalperAnalyticAttributionModelEnum.CROSS_DEVICE_LAST_YANDEX_DIRECT_CLICK,
    label: 'Последний клик из Яндекс.Директа на всех устройствах',
  },
];
